import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import "./Footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Footer = () => {
  return (
    <Fragment>
      <section className="footer-section">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-sm-center">
            <div className="col-lg-4 col-sm-8">
              <div className="footer-about">
                <div className="">
                  <NavLink
                    to="/"
                    className="d-flex position-relative align-items-center"
                  >
                    <img
                      src={logo}
                      width="12%"
                      alt="img not found"
                      loading="lazy"
                    />
                    <span className="ms-5 position-absolute text-white text-uppercase fw-semibold">
                      Kairaa techserve
                    </span>
                  </NavLink>
                </div>
                <p className="f-about-texts">
                  We offer the best technology solutions to our clients. Our
                  team is highly experienced and equipped with latest
                  technologies.
                </p>

                <ul className="footer-social-links d-flex gap-3 justify-content-xl-center justify-content-lg-start">
                  <li>
                    <a
                      href="https://www.facebook.com/Kairaa.tech"
                      target="_blank"
                    >
                      <FacebookIcon />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/kairaa_tech" target="_blank">
                      <XIcon />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/kairaatechserve/"
                      target="_blank"
                    >
                      <InstagramIcon />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/kairaa-tech-serve-17a625231/"
                      target="_blank"
                    >
                      <LinkedInIcon />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-sm-6 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-center pt-5 pt-lg-0 footer-contents">
              <div className="footer-widget">
                <h4 className="footer-widget-title">Services</h4>
                <ul className="footer-links">
                  <li>
                    <a href="/service/blockchain-development">Blockchain</a>
                  </li>
                  <li>  
                    <a href="/">App Development</a>
                  </li>
                  <li>
                    <a href="/service/web-application">Web Development</a>
                  </li>
                  <li>
                    <a href="/service/cryptoexchange-development">Crypto Exchange</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-sm-6 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-center pt-5 pt-lg-0 footer-contents">
              <div className="footer-widget">
                <h4 className="footer-widget-title">Company</h4>
                <ul className="footer-links">
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/">Terms</NavLink>
                  </li>
                  <li>
                    <NavLink to="/">Privacy Policy</NavLink>
                  </li>
                  <li>
                    <NavLink to="/">Careers</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-8 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-center pt-5 pt-lg-0 footer-contents">
              <div className="footer-widget text-sm-center text-xl-start">
                <h4 className="footer-widget-title">Contact</h4>
                <ul className="footer-contact-links">
                  <li>+91 7092770303</li>
                  <li>support@kairaatechserve.com</li>
                  <li>Kairaa Techserve Pvt,Ltd</li>
                  <li>Chennai - 600073.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-texts text-center pt-md-4 pt-3">
                <p>
                  ©<NavLink to="/">2025 Kairaatechserve</NavLink>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Footer;
